import { render, staticRenderFns } from "./IndustryPage.vue?vue&type=template&id=646eca66&scoped=true"
import script from "./IndustryPage.vue?vue&type=script&lang=ts"
export * from "./IndustryPage.vue?vue&type=script&lang=ts"
import style0 from "./IndustryPage.vue?vue&type=style&index=0&id=646eca66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646eca66",
  null
  
)

export default component.exports